import React from "react";
import Header from "../Comman/Header";
import NFTone from "./NFTone";
import Footer from "../Comman/Footer";
import NFTtable from "./NFTtable";
import SecureYouNFT from "./SecureYouNFT";
import SuperElite from "./SuperElite";
import HowToBuyNFT from "./HowToBuyNFT";
import WhyBuyNFTs from "./WhyBuyNFTs";

export default function BuyNFT() {
  return (
    <>
      <Header />
      <SecureYouNFT />
      <NFTone />
      <SuperElite />
      <HowToBuyNFT />
      <WhyBuyNFTs />
      {/* <NFTtable /> */}
      <Footer />
    </>
  );
}
